module.exports = __webpack_public_path__ + "static/ogX-10cf01db702c34025a27e2ade0cb34ef.jpg";